import { $, html, View } from 'rune-ts';
import { BannerTypeS } from '@services/MarppleShop/features/Banner/outbound/share.ts';
import anime from 'animejs';
import klass from '@services/MarppleShop/renderApp/pages/Main/views/DomainBanner/DomainBanner.module.scss';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { replaceNewlinesWithBr } from '@services/MarppleShop/shared/util';

export class DomainBannerInformationView extends View<{
  information: BannerTypeS.MainBannerData;
  active: boolean;
}> {
  deactivateAnime?: anime.AnimeInstance;
  activateAnime?: anime.AnimeInstance;

  override template() {
    const { navigate, title, sub_title, category, href, target } = this.data.information;

    return html`
      <div class="${this.data.active ? klass.active : klass.deactivate} ${klass.information}">
        <${href ? 'a' : 'div'}
          ${navigate ? html`data-post-message="${dataStr(navigate)}"` : ''}
          href="${html.preventEscape(href ?? '#')}"
          target="${target}"
          class="${klass.contents}">
          <span class="${klass.category} ${staticFont('bebas_16_bold')}">
            ${html.preventEscape(category?.toUpperCase() ?? '')}
          </span>
          <div class="${klass.title_wrapper}">
            <span class="${klass.title} ${font('20_bold')}">
              ${html.preventEscape(replaceNewlinesWithBr(title))}
            </span>
            <span class="${klass.desc} ${font('12_medium')}">${html.preventEscape(replaceNewlinesWithBr(sub_title))}</span>  
          </div>
        </${href ? 'a' : 'div'}>
      </div>
    `;
  }

  activate() {
    if (this.deactivateAnime && !this.deactivateAnime?.paused) {
      this.deactivateAnime?.pause();
    }

    const el = this.element();
    $(el).removeClass(klass.deactivate);

    if (this.activateAnime) {
      this.activateAnime.restart();
      return;
    }

    this.activateAnime = anime({
      targets: el,
      opacity: 1,
      duration: 500,
      easing: 'easeInOutQuad',
      complete: () => {
        $(el).addClass(klass.active);
        el.style.opacity = '';
      },
    });
  }

  deactivate() {
    if (this.activateAnime && !this.activateAnime?.paused) {
      this.activateAnime?.pause();
    }

    if (this.deactivateAnime) {
      this.deactivateAnime.restart();
      return;
    }

    const el = this.element();

    this.deactivateAnime = anime({
      targets: el,
      opacity: 0,
      duration: 500,
      easing: 'easeInOutQuad',
      complete: () => {
        $(el).addClass(klass.deactivate).removeClass(klass.active);
      },
    });
  }
}
